import React from "react";
import { Box } from "@chakra-ui/react";
import { Route, Routes } from "react-router-dom";
import { PageHeader } from "components";
import { ORGANIZATION_TABS } from "duck";
import { Admin, General, Users } from "./components";

const Edit: React.FC = () => (
  <>
    <PageHeader
      title="Edit Organization"
      backURL={-1}
      tabs={ORGANIZATION_TABS}
    />

    <Box mt={6}>
      <Routes>
        <Route path="/general" element={<General />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/users" element={<Users />} />
      </Routes>
    </Box>
  </>
);

export default Edit;
